export default __webpack_public_path__ + "static/media/books2-afterB-1920w.8bef90b4.webp";